import { useGetPatientDiagnosesQuery } from '~/store/services/diagnoses';
import { useMemo } from 'react';

export const usePatientActivePrimaryDiagnosis = (
  patientId: string,
): {
  isLoading: boolean;
  activePrimaryDiagnosis?: PatientDiagnosis;
} => {
  const { data: patientDiagnoses, isLoading: isGetPatientDiagnosesLoading } =
    useGetPatientDiagnosesQuery(patientId);

  const activePrimaryDiagnosis = useMemo(
    () =>
      patientDiagnoses?.find(
        (diagnosis) => diagnosis.active && diagnosis.primary,
      ),
    [patientDiagnoses],
  );

  return {
    isLoading: isGetPatientDiagnosesLoading,
    activePrimaryDiagnosis,
  };
};
